import HeroFlight from 'shared/lib/assets/img/landing/hero-flight.png';
import LogoNationwide from 'shared/lib/assets/img/logo/logo-nationwide.svg';

export const flightConfig = {
  hero: {
    heading: 'Coverage to get you to your next destination.',
    subheading:
      'Don’t make an at-the-counter decision on insurance for your rental car. SURE takes the pain out of the process to offer comprehensive coverage at a more affordable rate.',
    cta: 'Get flight insurance',
    ctaLink: '/',
    img: HeroFlight,
  },
  underwriter: {
    img: LogoNationwide,
    name: 'Assurant',
  },
  coverageDetails: [
    {
      heading: 'Theft or Damage to Personal Property',
      subheading:
        'From minor fender-benders to more serious accidents, you’ll be covered for physical damage to the vehicle up to $100,000. Anything that is yours in the car is covered, too.',
    },
    {
      heading: 'Lost Key Reimbursement',
      subheading:
        'Replacing keys is costly business—especially with a rental. The good news: This policy covers the price, so you can stress less.',
    },
    {
      heading: 'Flat Tire Expenses',
      subheading:
        'An errant nail sends you to the shoulder—but the cost of fixing your flat is covered.',
    },
    {
      heading: 'Towing Charges',
      subheading:
        'Mishaps happen on the road, and when you’re in need of a tow you can rest assured that the cost is covered.',
    },
    {
      heading: 'Misfueling Charges',
      subheading:
        'Cover the cost of draining and cleaning, or for accidental damage caused by driving with the wrong fuel.',
    },
  ],
  scenarioDetails: {
    heading: 'Why Would You Need Flight Insurance?',
    scenarios: [
      {
        heading: 'Scenario 1',
        subheading: 'Your purse is stolen—with the rental car keys inside.',
      },
      {
        heading: 'Scenario 2',
        subheading: 'Your purse is stolen—with the rental car keys inside.',
      },
      {
        heading: 'Scenario 3',
        subheading: 'Your purse is stolen—with the rental car keys inside.',
      },
      {
        heading: 'Scenario 4',
        subheading: 'Your purse is stolen—with the rental car keys inside.',
      },
    ],
  },
  comparison: [
    'Instant quote',
    'Buy and manage your policy in one place',
    'Insurance explained in simple, easy-to-digest way',
    'Mobile',
    'Endorsements',
    'Plan tailored to fit your needs',
  ],
};
